import { string } from "prop-types";

const PropImageField = {
  src: string,
  alt: string
};
export default PropImageField;